export default "/icons/aws.svg";